/**
 * Global Vue error handler: log the error and keep going.
 *
 * Without `app.config.errorHandler`, Vue 3 in DEVELOPMENT rethrows errors raised in
 * render functions, watchers and lifecycle hooks. A rethrow inside the scheduler aborts
 * the whole flush, so one bad expression blanks the page, cancels a route change or keeps
 * a dialog from opening. In PRODUCTION Vue 3 only logs them, and Vue 2 only logged them in
 * both modes. So the dev server showed failures production would not (the migration
 * crawlers found several). This makes dev behave like production and like Vue 2.
 *
 * Install it AFTER initSentry and it wraps Sentry's handler. Sentry 11 reports an error
 * as handled:false only when it finds no handler before its own (and then rethrows); that
 * keeps crash-free-session stats and error.unhandled alerts as they were on Vue 2. The
 * rethrow is stopped here, after Sentry has captured the error.
 *
 * The message keeps Vue 2's "Error in <phase>" wording and carries the error text, since
 * the crawlers in tools/migracao/crawler read console text, not the error object.
 */
export function instalarTratadorDeErros(app) {
  const anterior = app.config.errorHandler;
  app.config.errorHandler = (erro, instancia, info) => {
    if (typeof anterior === "function") {
      try {
        anterior.call(app, erro, instancia, info);
      } catch (relancado) {
        // Sentry without a previous handler rethrows after capturing: nothing to add.
        if (relancado !== erro) {
          // eslint-disable-next-line no-console
          console.error("[Vue] errorHandler anterior falhou", relancado);
        }
      }
    }
    const nome = (instancia && (instancia.$options.name || instancia.$.type.__name)) || "Anonymous";
    const texto = erro instanceof Error ? `${erro.name}: ${erro.message}` : String(erro);
    // eslint-disable-next-line no-console
    console.error(`[Vue] Error in ${info} (<${nome}>): ${texto}`, erro);
  };
}
